import { ILink } from "@types";
import { SLUGS } from "consts/slugs";

export function getReferralPath(pathname: string): string {
  const path = pathname.split("?")[0];
  if (typeof window === "undefined") {
    return path;
  }
  return path + window.location.hash;
}

export function addRefferalToContactLink(link: ILink, currentQuery: any, asPath: string) {
  let linkCopy = link;
  if (link.href.startsWith(SLUGS.contact)) {
    const fullPath = link.href + (link.slug || "");
    const [path, query] = fullPath.split("?");
    const queryParams = new URLSearchParams(query);
    queryParams.set("referral", getReferralPath(asPath));
    linkCopy = {
      href: `${path}?${queryParams.toString()}`,
    };
  }
  return linkCopy;
}
